var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3C20.0304 3 20.5391 3.21071 20.9142 3.58579C21.2893 3.96086 21.5 4.46957 21.5 5V19C21.5 19.5304 21.2893 20.0391 20.9142 20.4142C20.5391 20.7893 20.0304 21 19.5 21H5.5C4.96957 21 4.46086 20.7893 4.08579 20.4142C3.71071 20.0391 3.5 19.5304 3.5 19V5C3.5 4.46957 3.71071 3.96086 4.08579 3.58579C4.46086 3.21071 4.96957 3 5.5 3H19.5ZM19 18.5V13.2C19 12.3354 18.6565 11.5062 18.0452 10.8948C17.4338 10.2835 16.6046 9.94 15.74 9.94C14.89 9.94 13.9 10.46 13.42 11.24V10.13H10.63V18.5H13.42V13.57C13.42 12.8 14.04 12.17 14.81 12.17C15.1813 12.17 15.5374 12.3175 15.7999 12.5801C16.0625 12.8426 16.21 13.1987 16.21 13.57V18.5H19ZM7.38 8.56C7.82556 8.56 8.25288 8.383 8.56794 8.06794C8.883 7.75288 9.06 7.32556 9.06 6.88C9.06 5.95 8.31 5.19 7.38 5.19C6.93178 5.19 6.50193 5.36805 6.18499 5.68499C5.86805 6.00193 5.69 6.43178 5.69 6.88C5.69 7.81 6.45 8.56 7.38 8.56ZM8.77 18.5V10.13H6V18.5H8.77Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFill);
export default __webpack_public_path__ + "static/media/linkedin-fill.6645f8c82a5b3c8c2dbb202aa7854785.svg";
export { ForwardRef as ReactComponent };